export enum ColumnWidth {
    EXTRAWIDE = 600,
    WIDE = 450,
    NORMAL = 250,
    SMALL = 150
}
